import React from 'react';

import { Trans } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Typography } from '@lyearn/ui';

function Order({ className, order }: { className?: string; order: number }) {
  return (
    <Typography
      className={cn('index mb-8', className)}
      color="text-text-secondary"
      variant="body-short-02">
      <Trans i18nKey="Exercise:Question" /> {order}
    </Typography>
  );
}

export default Order;
